module.exports = __webpack_public_path__ + "4df1e7ea39eff61c0cfc549168db9cc8.svg";